import type { Breadcrumb } from './types'

const MAX_CRUMBS = 30
const MAX_MESSAGE_CHARS = 200

/** 고정 길이 링버퍼. 입력값 같은 민감 데이터는 호출부가 넣지 않는 것이 원칙이다. */
export class BreadcrumbBuffer {
  private readonly crumbs: Breadcrumb[] = []

  push(crumb: Omit<Breadcrumb, 'ts'>, now: number): void {
    const data = crumb.data ? sanitizeData(crumb.data) : undefined
    this.crumbs.push({
      ts: now,
      type: crumb.type,
      message: String(crumb.message).slice(0, MAX_MESSAGE_CHARS),
      ...(data ? { data } : {}),
    })
    if (this.crumbs.length > MAX_CRUMBS) {
      this.crumbs.shift()
    }
  }

  snapshot(): Breadcrumb[] {
    return [...this.crumbs]
  }
}

function sanitizeData(
  data: Record<string, string | number | boolean>,
): Record<string, string | number | boolean> | undefined {
  const out: Record<string, string | number | boolean> = {}
  let count = 0
  for (const [key, value] of Object.entries(data)) {
    if (count >= 10) break
    const type = typeof value
    if (type === 'string') {
      out[key] = (value as string).slice(0, MAX_MESSAGE_CHARS)
      count++
    } else if (type === 'number' || type === 'boolean') {
      out[key] = value
      count++
    }
  }
  return count > 0 ? out : undefined
}
